export const categoryOptions: {id: string; name: string}[] = [
  { id: 'Aplicación', name: 'Aplicación' },
  { id: 'Complementos para firma', name: 'Complementos para firma' },
];

export const teamCategoryOptions: {id: string; name: string}[] = [
  { id: 'Sales', name: 'Sales' },
  { id: 'Risk', name: 'Risk' },
];
